<template>
  <div class="grid grid-cols-5 px-1 py-2 border-color border-b-1 sr-eye-ex-buy">
    <div class="text-start capitalize">{{ exBuy }}</div>
    <div class="flex justify-center items-center capitalize">{{ $t('long') }}</div>
    <div class="flex justify-center items-center">
      <span v-if="priceBuy">{{ priceBuy }}</span>
      <Skeleton width="40px" v-else></Skeleton>
    </div>
    <div class="flex justify-center items-center">
      <span v-if="volBuy">{{ Number(volBuy).toFixed(2) }}</span>
      <Skeleton width="40px" v-else></Skeleton>
    </div>
    <div class="flex justify-end items-center">
      <span v-if="priceBuy">{{ amount ? Number(priceBuy * Number(amount) / (Number(leverage) ??
        1)).toFixed(2) :
        '—' }} USDT</span>
      <Skeleton width="40px" v-else></Skeleton>
    </div>
  </div>
  <div class="grid grid-cols-5 px-1 py-2 sr-eye-ex-sell">
    <div class="text-start capitalize">{{ exSell }}</div>
    <div class="flex justify-center items-center capitalize">{{ $t('short') }}</div>
    <div class="flex justify-center items-center">
      <span v-if="priceSell">{{ priceSell }}</span>
      <Skeleton width="40px" v-else></Skeleton>
    </div>
    <div class="flex justify-center items-center">
      <span v-if="volSell">{{ Number(volSell).toFixed(2) }}</span>
      <Skeleton width="40px" v-else></Skeleton>
    </div>
    <div class="flex justify-end items-center">
      <span v-if="priceSell">{{ amount ? Number(priceSell * Number(amount) / (Number(leverage) ??
        1)).toFixed(2)
        : '—' }}
        USDT</span>
      <Skeleton width="40px" v-else></Skeleton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Skeleton from 'primevue/skeleton';

defineProps<{
  priceSell: number | null,
  priceBuy: number | null,
  amount: number | null | undefined,
  volSell: number | null,
  volBuy: number | null,
  exBuy: string | null,
  exSell: string | null,
  leverage: number | null | undefined,
}>()
</script>
